export const urlFormattedTypeParam = (type: string) => {
  return type?.split(' ')?.join('-')?.toLowerCase()
}

export const urlFormattedYearParam = (years: string[]) => {
  return years.length ? years.join(',') : ''
}
